(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  class InstagramFeed extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        observer.unobserve(this);
        const _this = this;
        const container = this.querySelector('#Instagram');

        var loadInstagram = function(accessToken) {
          var limit	= parseInt(_this.dataset.limit)	? parseInt(_this.dataset.limit)	: 8,
              feed	= new Instafeed({
                target: container,
                accessToken: accessToken,
                limit: limit,
                template: '<a href="{{link}}" target="_blank" rel="noreferrer noopener" draggable="false" aria-label="Instagram"><figure><img src="{{image}}" alt="" draggable="false" loading="lazy" width="auto" height="auto"></figure><div class="overlay text-tiny"><div>{{caption}}</div></div></a>',
                filter: function(image) {
                  return image.type === 'image';
                },
                after: function () {
                  _this.classList.remove('hidden');
                  setTimeout(function(){
                    _this.querySelector('.grid').classList.add('slider');
                  }, 100);
                },
                error: function () {
                  console.error('Instagram error.');
                  sessionStorage.removeItem('InstagramToken');
                }
              });
          feed.run();
          
          try {
            sessionStorage.setItem('InstagramToken', accessToken);
          } catch (e) {
            // No local storage.
          }
        };

        var loadInstafeed = function(accessToken) {
          var scriptTag = document.createElement('script');
          scriptTag.src = window.routes.asset_url + 'instafeed.js';
          scriptTag.onload = function(){ loadInstagram(accessToken); };
          scriptTag.onreadystatechange	= function(){ loadInstagram(accessToken); };
          document.body.appendChild(scriptTag);
        };
        
        var sessionToken;
        try {
          sessionToken = sessionStorage.getItem('InstagramToken');
        } catch (e) {
          // Not set.
        }
        
        if (sessionToken && sessionToken) {
          loadInstafeed(sessionToken);
        } else {
          fetch(_this.dataset.token)
            .then(response => response.json())
            .then(data => {
              if (data.Token) {
                loadInstafeed(data.Token)
              } else {
                console.error(`Instagram error.`, data['Error']);
                sessionStorage.removeItem('InstagramToken');
              }
            })
            .catch(error => {
              console.error(`Instagram error.`, error);
              sessionStorage.removeItem('InstagramToken');
            });
        }
      }

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('instagram-feed', InstagramFeed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  class Popup extends HTMLElement {
    constructor() {
      super();
      
      if (typeof localStorage === 'object') {
        try {
          localStorage.setItem('localStorage', 1);
          localStorage.removeItem('localStorage');
        } catch (e) {
          Storage.prototype._setItem = Storage.prototype.setItem;
          Storage.prototype.setItem = function() {};
        }
        
        var date = Math.round(Date.now() / 1000),
            days = Math.floor((date - localStorage.getItem('popDate')) / 60 / 60 / 24);
        
        if (localStorage.getItem('popState') != 'shown' || days >= Math.max(this.dataset.hide, 0)) {
          setTimeout(function() {
            document.documentElement.classList.add('pop');
          }, parseInt(this.dataset.delay) * 1000);
        }
      }
    }
  }

  customElements.define('pop-up', Popup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            
            if (recommendations && recommendations.innerHTML.trim().length) {
              const currentTabs = document.querySelector('.tabs ul');
              const currentSliders = document.querySelector('.sliders');

              if (currentTabs) {
                currentTabs.insertAdjacentHTML('beforeend',
                  recommendations.querySelector('.tabs ul').innerHTML.replace('class="active"', '')
                );
                currentSliders.insertAdjacentHTML('beforeend',
                  recommendations.querySelector('.sliders').innerHTML.replace('featured-slider-container', 'featured-slider-container hidden')
                );
              } else {
                this.innerHTML = recommendations.innerHTML;
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
